import { useCallback, useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

/** Outcomes shown on the booking updates timeline (skip routine cron skips). */
const TIMELINE_OUTCOMES = ["updated", "would_update", "error"] as const;

export interface BookingAutomationTimelineEvent {
  id: string;
  automation_id: string;
  outcome: string;
  previous_status: string | null;
  new_status: string | null;
  has_utb: boolean | null;
  has_ttw: boolean | null;
  document_count: number | null;
  error_message: string | null;
  created_at: string;
}

export function useBookingAutomationTimeline(bookingId: number | undefined) {
  const [events, setEvents] = useState<BookingAutomationTimelineEvent[]>([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!bookingId) {
      setEvents([]);
      return;
    }
    setLoading(true);
    const { data, error } = await supabase
      .from("booking_automation_run_items")
      .select(
        "id, automation_id, outcome, previous_status, new_status, has_utb, has_ttw, document_count, error_message, created_at"
      )
      .eq("booking_id", bookingId)
      .in("outcome", [...TIMELINE_OUTCOMES])
      .order("created_at", { ascending: false });

    if (error) {
      setEvents([]);
    } else {
      setEvents((data as BookingAutomationTimelineEvent[]) ?? []);
    }
    setLoading(false);
  }, [bookingId]);

  useEffect(() => {
    load();
  }, [load]);

  return { events, loading, reload: load };
}
